import {css} from 'lit';
export const styles = css`header,
footer {
  display: flex;
  min-height: 50px;
  justify-content: center;
  align-items: center;
  border-top: 1px solid var(--border-light);
  border-bottom: 1px solid var(--border-light);
}

main {
  width: 400px;
  height: 400px;
  overflow-y: auto;
}

xs-notification {
  --border-radius: 0;
}

.trigger {
  position: relative;
  height: 59px;
  display: flex;
  align-items: center;
  padding-left: 12px;
  padding-right: 12px;
  color: var(--page-header-color);
  background-color: transparent;
  border: none;
}

@media (min-width: 992px) {

.trigger {
    height: 50px
}
  }

@media (hover: hover) {
    .trigger:hover {
      color: var(--page-header-color);
      opacity: 0.7;
    }
  }

.trigger ef-icon {
    --secondary: var(--danger);

    font-size: 24px;

    font-size: var(--page-header-icon-size, 24px);
  }

ef-dropdown[open] .trigger,
.trigger:active {
  background-color: var(--page-header-active-bg);
}
`;
export default styles;
